import { render, staticRenderFns } from "./yaliceshi.vue?vue&type=template&id=614aa5ca&scoped=true"
import script from "./yaliceshi.vue?vue&type=script&lang=js"
export * from "./yaliceshi.vue?vue&type=script&lang=js"
import style0 from "./yaliceshi.vue?vue&type=style&index=0&id=614aa5ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614aa5ca",
  null
  
)

export default component.exports